/**
 * @generated SignedSource<<587e3013cfcf9e07af66b89cd068850b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type placementsEnablePlacementMutation$variables = {
  id: string;
  isEnabled: boolean;
};
export type placementsEnablePlacementMutation$data = {
  readonly enablePlacementOutput: {
    readonly placementOutput: {
      readonly id: string;
      readonly isEnabled: boolean;
    } | null;
  };
};
export type placementsEnablePlacementMutation = {
  response: placementsEnablePlacementMutation$data;
  variables: placementsEnablePlacementMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isEnabled"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "isEnabled",
        "variableName": "isEnabled"
      }
    ],
    "concreteType": "PlacementOutput_Output",
    "kind": "LinkedField",
    "name": "enablePlacementOutput",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PlacementOutput",
        "kind": "LinkedField",
        "name": "placementOutput",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isEnabled",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "placementsEnablePlacementMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "placementsEnablePlacementMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d29158490cd3314bf6ef18e2dcf005dc",
    "id": null,
    "metadata": {},
    "name": "placementsEnablePlacementMutation",
    "operationKind": "mutation",
    "text": "mutation placementsEnablePlacementMutation(\n  $id: ID!\n  $isEnabled: Boolean!\n) {\n  enablePlacementOutput(id: $id, isEnabled: $isEnabled) {\n    placementOutput {\n      id\n      isEnabled\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8b2728e9733fce83274d79361afce642";

export default node;
